<template lang="pug">
  .files-list
    .files-list__item(
      v-if='attachments.length === 0'
    )
      span Нет документов
    .files-list__item(
      v-for='(file, index) in attachments'
      :key='file.name + index'
    )
      label.attached-file
        .button
          .attached-file__checkbox
            .checkbox
              input.checkbox__input(
                type="checkbox"
                v-model="file.checked"
              )
              .checkbox__icon
          .button__icon
            img(src="@/assets/images/icons/doc.svg")
          .button__text {{ file.name }}
</template>

<script>
export default {
  name: "FilesList",
  props: {
    attachments: {
      type: Array,
      default: () => []
    }
  }
};
</script>
